import { ExternalLinkIcon } from '@heroicons/react/outline';
import { useChain } from 'contexts';
import React from 'react';
import type { CardProps } from './types';

type Props = CardProps & {
  body: React.ReactNode;
  icon?: React.ElementType;
  url?: string;
};

const ResourceCard: React.FC<Props> = ({ title, icon: Icon, body, url }) => {
  const { styleSlug } = useChain();
  return (
    <div
      className={`rounded-xl bg-${styleSlug}-primary bg-gradient-to-l dark:from-${styleSlug}-light dark:to-${styleSlug}-primary`}
      style={{ padding: 2 }}
    >
      <a
        href={url}
        target="_blank"
        rel="noreferrer"
        className={`flex items-start space-x-2 px-4 py-3 rounded-10 bg-white dark:bg-gray-111 overflow-hidden`}
      >
        {Icon && (
          <Icon
            className={`mt-1 text-${styleSlug}-primary dark:text-${styleSlug}-light`}
            style={{ flex: '0 0 20px ' }}
          />
        )}
        <span className="flex-grow space-y-1">
          <span className="flex items-start justify-between">
            <span className={`text-22 text-gray-444 dark:text-white`}>{title}</span>
            <ExternalLinkIcon
              className={`w-5 h-5 mt-1.5 text-${styleSlug}-primary dark:text-${styleSlug}-light`}
            />
          </span>
          <span className="block text-sm text-gray-999">{body}</span>
        </span>
      </a>
    </div>
  );
};

export default ResourceCard;
